export const PRIORITY_COLOR: { [key: string]: string } = {
  high: '#ee5253',
  middle: '#2e86de',
  low: '#ff9f43',
}
